import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions, RowClassRules } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { QualityTestService } from '../../quality-test/quality-test.service';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';
import { HttpParams } from '@angular/common/http';
import { ListingQualityStatusService } from '@app/_components/listing-quality-status/listing-quality-status.service';
import { DatePipe } from '@angular/common';
import { ContextMenu } from 'primeng/contextmenu';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-rates-report',
    templateUrl: './rates-report.component.html',
    styleUrls: ['./rates-report.component.css'],
    standalone: false
})
export class RateReportComponent implements OnInit {

	@Input() groupDefaultExpanded: any = 0;

	gridOptions: any;
	rowData = []; // To store the API response
	columnDefs: ColDef[] = [
		//Columns
		{ headerName: 'Property', field: 'propertyCode', sortable: true, filter: 'agTextColumnFilter', pinned: "left"},
		{ headerName: 'Min Last Update', field: 'minLastUpdateDate.testResultValue', sortable: true, filter: 'agTextColumnFilter',
			cellClass: (params) => this.getCellClassForTestResult(params.data?.minLastUpdateDate),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return this.datePipe.transform(params?.value?.testResultValue, 'MM/dd/yyyy, h:mm a'); // Using date pipe to format
				}
				else
				{
					return '';
				}
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
			// Return the full object (not just the formatted value) for sorting purposes
			return params.data?.minLastUpdateDate; // Returns the entire object, not just testResultValue
			},
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB)
		},
		{ headerName: 'Max Last Update', field: 'maxLastUpdateDate.testResultValue', sortable: true, filter: 'agTextColumnFilter',
			cellClass: (params) => this.getCellClassForTestResult(params.data?.maxLastUpdateDate),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return this.datePipe.transform(params?.value?.testResultValue, 'MM/dd/yyyy, h:mm a'); // Using date pipe to format
				}
				else
				{
					return '';
				}
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
			// Return the full object (not just the formatted value) for sorting purposes
			return params.data?.maxLastUpdateDate; // Returns the entire object, not just testResultValue
			},
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB)
		},
		{ headerName: 'Min Nightly Rate', field: 'minNightlyRate.testResultValue', sortable: true, filter: 'agTextColumnFilter',
		  valueFormatter: (params) => {
			if (params.data?.testSubjectName === 'FAIL Counts') {
				return params.value; // Display the raw count, no date formatting
			}
			if(params?.value)
			{
				return parseFloat(params.value).toFixed(2);
			}
			else
			{
				return '';
			}
		  },
		  cellClass: (params) => this.getCellClassForTestResult(params.data?.minNightlyRate),
		  valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
			// Return the raw numeric value (not the formatted one) for sorting purposes
			return params.data?.minNightlyRate?.testResultValue ? parseFloat(params.data?.minNightlyRate.testResultValue) : 0;
		  },
		},
		{ headerName: 'Nightly Rate', field: 'propertyNightlyRate.testResultValue', sortable: true, filter: 'agTextColumnFilter',
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyNightlyRate),
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyNightlyRate; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB) },
		{ headerName: 'DepartureHousekeeping', field: 'propertyDepartureHousekeeping.testResultValue', sortable: true, filter: 'agTextColumnFilter',
			valueFormatter: (params) => {
					if (params.data?.testSubjectName === 'FAIL Counts') {
						return params.value; // Display the raw count, no date formatting
					}
					return '';
				},
			cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyDepartureHousekeeping),
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyDepartureHousekeeping; // Returns the entire object, not just testResultValue
			  },
			  comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Damage Waiver', field: 'propertyDamageWaiver.testResultValue', sortable: true, filter: 'agTextColumnFilter',
			cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyDamageWaiver),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyDamageWaiver; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Resort Fee', field: 'propertyResortFee.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyResortFee),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyResortFee; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'HotTub', field: 'propertyHotTub.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyHotTub),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyHotTub; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Firewood', field: 'propertyFirewood.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyFirewood),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyFirewood; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Destination Fee', field: 'propertyDestinationFee.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyDestinationFee),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyDestinationFee; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Convenience Fee', field: 'propertyConvenienceFee.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyConvenienceFee),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyConvenienceFee; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Free Car', field: 'propertyFreeCar.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.propertyFreeCar),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.propertyFreeCar; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Rate Created Today', field: 'rateCreatedToday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateCreatedToday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateCreatedToday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Rate Created Yesterday', field: 'rateCreatedYesterday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateCreatedYesterday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateCreatedYesterday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Rate Created Avg', field: 'rateCreatedAvg.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateCreatedAvg),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateCreatedAvg; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'RateLos Created Today', field: 'rateLosCreatedToday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateLosCreatedToday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateLosCreatedToday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'RateLos Created Yesterday', field: 'rateLosCreatedYesterday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateLosCreatedYesterday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateLosCreatedYesterday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'RateLos Created Avg', field: 'rateLosCreatedAvg.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.rateLosCreatedAvg),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.rateLosCreatedAvg; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Reservation Created Today', field: 'reservationCreatedToday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.reservationCreatedToday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.reservationCreatedToday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Reservation Created Yesterday', field: 'reservationCreatedYesterday.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.reservationCreatedYesterday),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.reservationCreatedYesterday; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
		{ headerName: 'Reservation Created Avg', field: 'reservationCreatedAvg.testResultValue', sortable: true, filter: 'agTextColumnFilter', cellClass: (params) => this.getCellClassForTestResult(params.data?.reservationCreatedAvg),
			valueFormatter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					return params.value; // Display the raw count, no date formatting
				}
				if(params?.value?.testResultValue)
				{
					return params.value.testResultValue
				}
				return '';
			  },
			valueGetter: (params) => {
				if (params.data?.testSubjectName === 'FAIL Counts') {
					const keys = params.colDef.field.split('.');
					if (keys.length > 0) {
						const firstKey = keys[0];
						return params.data[firstKey].testResultValue; // Return the count value for summary row
					}
				}
				// Return the full object (not just the formatted value) for sorting purposes
				return params.data?.reservationCreatedAvg; // Returns the entire object, not just testResultValue
			  },
			comparator: (nodeA, nodeB) => this.customStatusComparator(nodeA, nodeB),
		},
	];
  	rowDataGrouped = [];
	loading = true; // To indicate loading state
	counts = {};
	gridData = [];
	menuItems: MenuItem[];
	selectedRowData: any;
	selectedColumnName: any;
	@ViewChild('cm') cm: ContextMenu;

	constructor(
		public messageService: MessageService,
		public qualityTestServiceWiki : ListingQualityStatusService,
		public qualityTestService : QualityTestService,
		private constantService: ConstantService,
		private router: Router,
		private datePipe: DatePipe) {
			this.gridOptions = {
        // rowData: null,
        groupHeaderHeight: 75,
        headerHeight: 175,
        floatingFiltersHeight: 50,
        onGridReady: (params) => {
				  this.onGridReady(params);
				},
				// Additional grid configurations as necessary
			  };
			  this.menuItems = [
				{ label: 'Refresh', icon: 'pi pi-check', command: () => this.runQualityTestByProperty(this.selectedRowData) },
				{ label: 'Fix now', icon: 'pi pi-check', command: () => this.fixNow(this.selectedColumnName, this.selectedRowData) },
			  ];
		 }

	gridApi: GridApi;
	columnApi: ColumnApi;


	autoGroupColumnDef = {
		headerName: 'Property',
		cellRendererParams: {
			suppressCount: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	runQualityTestAllProperty()
	{
		//run for all properties
		let selectedRowData = {};
		this.runQualityTestByProperty(selectedRowData);
	}

	fixNow(selectedColumnName, selectedRowData)
	{
		console.log(selectedColumnName);
		console.log(selectedRowData)
		let maxLastUpdateDate = 'maxLastUpdateDate';
		let minLastUpdateDate = 'minLastUpdateDate';
		let minNightlyRate = 'minNightlyRate';
		if(selectedColumnName.includes(maxLastUpdateDate) 
			|| selectedColumnName.includes(minLastUpdateDate)
			|| selectedColumnName.includes(minNightlyRate))
		{
			this.redirectToProperty(selectedRowData.yieldMaxPropertyId, 2);
		}
	}

	/**
	   * Redirect to Property page on YM filtered by current dialog property
	   * @param opsNoteDetail 
	   * @param defaultTabIndx 
	   */
	  redirectToProperty(yieldMaxPropertyId:any, defaultTabIndx: any)
	  {
		let baseUrl = '/property-config/'+yieldMaxPropertyId;
		
		baseUrl = baseUrl + '/' + defaultTabIndx;
		
		const url = this.router.serializeUrl(
			this.router.createUrlTree([baseUrl])
		  );
		  window.open(url, '_blank');
	  }

	runQualityTestByProperty(selectedRowData)
	{
		let shortTermRentalIds = []
		if(selectedRowData && selectedRowData.shortTermRentalId)
		{
			shortTermRentalIds = [selectedRowData.shortTermRentalId]
		}
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quality report started in Background. Please wait for 3-5 minutes', life: 3000 });
		this.testRateQualityStatus(shortTermRentalIds);
		this.testListingQualityStatus(shortTermRentalIds);	
		this.testFeeAndTaxQualityStatus(shortTermRentalIds);
		this.testYieldMaxQualityStatus(shortTermRentalIds);
	}

	testYieldMaxQualityStatus(shortTermRentalIds)
	{
		this.qualityTestService.testListingQualityStatusByExtIds(shortTermRentalIds)
				.subscribe(
					res => {
						console.log('testListingQualityStatusByExtIds: ' + JSON.stringify(res));
						this.formLoading = false;
						this.ngOnInit();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'YieldMax Listing quality run successfully.', life: 3000 });
					},
					err => {
						this.formLoading = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
	}

	testRateQualityStatus(shortTermRentalIds) {
		try {
			this.formLoading = true;
				this.qualityTestServiceWiki.testRateQualityStatus(shortTermRentalIds)
					.subscribe(
						res => {
							console.log('testRateQualityStatus: ' + JSON.stringify(res));
							this.formLoading = false;
							this.ngOnInit();
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rate quality run successfully.', life: 3000 });
						},
						err => {
							this.formLoading = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: JSON.stringify(error), life: 3000 });
		}
	}

	testFeeAndTaxQualityStatus(shortTermRentalIds) {
		try {
			
			this.formLoading = true;
				this.qualityTestServiceWiki.testFeeAndTaxQualityStatus(shortTermRentalIds)
					.subscribe(
						res => {
							console.log('testFeeAndTaxQualityStatus: ' + JSON.stringify(res));
							this.formLoading = false;
							this.ngOnInit();
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Fees and Tax quality run successfully.', life: 3000 });
						},
						err => {
							this.formLoading = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: JSON.stringify(error), life: 3000 });
		}
	}

	testListingQualityStatus(shortTermRentalIds) {
		try {
			
			this.formLoading = true;
				this.qualityTestServiceWiki.testListingQualityStatus(shortTermRentalIds)
					.subscribe(
						res => {
							console.log('testListingQualityStatus: ' + JSON.stringify(res));
							this.formLoading = false;
							this.ngOnInit();
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Listing quality run successfully.', life: 3000 });
						},
						err => {
							this.formLoading = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.formLoading = false; });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: JSON.stringify(error), life: 3000 });
		}
	}

	onRowClicked(event) {
		this.selectedRowData = event.data;
		this.cm.show(event.event);
	}
	
	onCellClicked(event)
	{
		this.selectedColumnName = event.column.getColId();
	}

	getCellClassForTestResult(params) {
		if (params != null && params.testResultStatus === 'FAIL') {
		  return 'health-dashboard-error';
		} else if (params != null && params.testResultStatus === 'WARN') {
		  return 'health-dashboard-warning';
		}
		return '';
	}

	customStatusComparator(nodeA, nodeB) {
		// Check if the required fields exist
		const statusA = nodeA?.testResultStatus;
		const statusB = nodeB?.testResultStatus;

		// Custom order for statuses
		const statusOrder = { 'FAIL': 1, 'WARN': 2, 'PASS': 3 };

		// If statusA or statusB is undefined or not found, treat it as 0 (neutral)
		const orderA = statusOrder[statusA] !== undefined ? statusOrder[statusA] : 4;
		const orderB = statusOrder[statusB] !== undefined ? statusOrder[statusB] : 4;

		// Compare based on custom order
		if (orderA < orderB) {
		  return -1;
		} else if (orderA > orderB) {
		  return 1;
		} else {
		  return 0;
		}
	  }

	// forms
	formLoading = false;

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	ngOnInit(): void {
		let event: LazyLoadEvent = {};
		this.getQualityTestWiki(event);
	}

	getQualityTestWiki(event: LazyLoadEvent)
	{
		event['filters'] = {};
		let testCategoryFilter = { 'category': { 'value': ['Rates','PropertyFeesConfig','Review','Rate_LOS','RESERVATION'], 'matchMode': 'in' } };
		Object.assign(event['filters'], testCategoryFilter);
		try {
			this.qualityTestServiceWiki.qualityTestReport(
				0, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe().subscribe(

					(res: any) => {
						this.rowDataGrouped = res.data.qualityTests
						this.updateFailCounts();
						this.createGridData();
						this.loading = false; // Set loading to false once data is loaded
					},
					(err: any) => {
						this.loading = false;
					},
					() => { }
				);
		} catch (error) {
			this.loading = false;
			console.log('loadLazy(' + event + ')' + error);
		}

	}

	updateFailCounts() {
		this.counts = {};  // Reset counts before updating

		this.rowDataGrouped.forEach(row => {
		  this.columnDefs.forEach(col => {
			const field = col.field;
			const value = this.getNestedProperty(row, field);
			if(field == 'propertyCode')
			{
				this.counts[field] = value;
			}
			if (value && value.testResultStatus === 'FAIL') {
			  this.counts[field] = (this.counts[field] || 0) + 1;  // Increment count for 'FAIL'
			}
		  });
		});
	  }

	  getNestedProperty(obj: any, path: string) {
		const keys = path.split('.');
		if (keys.length > 0) {
		  const firstKey = keys[0];
		  const firstValue = obj[firstKey];
		  return firstValue;
		}
		return undefined;
	  }

	  createGridData() {
		// Create a new row for the counts, and add it at the start
		const failCountRow = this.createFailCountRow();
		(this.gridOptions as any).api.setPinnedTopRowData([failCountRow]);
		this.gridData = [...this.rowDataGrouped];
	  }

	  createFailCountRow() {
		const failCountRow = {
		  testSubjectName: 'FAIL Counts', // Set a static label for the row
		};

		this.columnDefs.forEach(col => {
			const keys = col.field.split('.')
			let firstKey: any;
			if (keys.length > 0)
			  firstKey = keys[0];
		//   const field = col.field;
			const field = firstKey;
			if(field == 'propertyCode')
			{
				failCountRow['propertyCode'] = 'FAIL Count';
			}
			else
			{
				//   failCountRow[field] = this.counts[col.field] || 0; // Use the fail count for each column
				failCountRow[field] = {'testResultValue' : this.counts[col.field] || 0};
			}
		});

		return failCountRow;
	  }

	ngAfterViewInit(): void {

	}

	onGridReady(grid: any): void {
		this.gridOptions.api = grid.api;
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

}
